import { t } from "i18next";
import {
  MDBBtn,
  MDBInput,
  MDBTextArea,
  MDBAutocomplete,
} from "mdb-react-ui-kit";
import React, { useState, useEffect, useRef } from "react";
import { Controller } from "react-hook-form";
import {
  getCreditCardUrl,
  LocAddressSeach,
} from "../../../apiclients/streamsapi_bridge";
import { CANADA, USA } from "../../images";

export default function BillingPreferences({
  register,
  setValue,
  errors,
  setError,
  watch,
  clearErrors,
  billingTypesList,
  countryList,
  states,
  billinggrpid,
  control
}) {
  const [billingType, setBillingType] = useState("");
  const handleBillingTypeChange = (event) => {
    setBillingType(event.target.value);
  };
  const [addressReasults, setAddressReasults] = useState([]);
  const [isDisplay, setisDisplay] = useState(false);
  const allowAPI = useRef(true);
  const [typingTimeout, setTypingTimeout] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    // Cleanup function to clear timeout when component unmounts or input value changes
    return () => {
      if (typingTimeout) {
        clearTimeout(typingTimeout);
      }
    };
  }, [typingTimeout]);

  function handleSearchAddressChange(searchValue) {
    try {
      clearErrors("billing_preference.street_addr");
      setValue("billing_preference.street_addr", searchValue, {
        shouldDirty: true,
      });
      if (typingTimeout) {
        clearTimeout(typingTimeout);
      }
      const newTimeout = setTimeout(() => {
        sendApIRequest(searchValue);
      }, 500);
      // Update the typingTimeout state with the new timeout
      setTypingTimeout(newTimeout);
    } catch (error) {
      console.log(`Error in handleSearchAddressChange :::: ${error}`);
    }
  }

  const sendApIRequest = async (searchValue) => {
    try {
      if (searchValue.trim() !== "" && allowAPI.current) {
        //if (searchValue.trim() !== "") {
        let update = {
          reqid: 84,
          search: searchValue,
          siteid: JSON.parse(sessionStorage.getItem("admin_session")).siteid,
        };
        setIsLoading(true);
        console.log("Request for the search :::::: " + JSON.stringify(update));
        const serverResponse = await LocAddressSeach(update);
        setIsLoading(false);
        if (!serverResponse.ok) {
          console.log("Network response was not ok");
          throw new Error("Network response was not ok");
        } else {
          const responseData = await serverResponse.json();
          console.log("Response Data:", JSON.stringify(responseData));
          let addressList = responseData?.message?.suggestions ?? [];
          setAddressReasults(addressList);
          if (addressList.length === 0) {
            setisDisplay(false);
          } else {
            setisDisplay(true);
          }
        }
      } else {
        allowAPI.current = true;
        setisDisplay(false);
      }
    } catch (error) {
      console.log(`Error in sendApIRequest for address search :::: ${error}`);
    }
  };
  function handleAddressSelect(address) {
    if (address.street_line) {
      // setaddressValue(address.street_line);
      setValue("billing_preference.street_addr", address.street_line, {
        shouldDirty: true,
      });
    }
    if (address.city) {
      setValue("billing_preference.city", address.city, { shouldDirty: true });
    }
    if (address.state) {
      const stateObj = states.find(
        (state) => state.statecode.trim() === address.state.trim()
      );
      console.log("stateObj :::::::: " + JSON.stringify(stateObj));
      if (stateObj) {
        setValue("billing_preference.state", stateObj.sid, {
          shouldDirty: true,
        });
      }
    }
    if (address.zipcode) {
      setValue("billing_preference.zip", address.zipcode, {
        shouldDirty: true,
      });
    }
  }

  async function handleCreditCard() {
    try {
      let apiResponse = await getCreditCardUrl(
        JSON.parse(sessionStorage.getItem("admin_session")).siteid,
        billinggrpid
      );
      const rawData = await apiResponse.json();
      console.log("apiResponse ::::::::::::::: " + JSON.stringify(rawData));

      if (rawData.status === "success") {
        if (rawData.unique_key) {
          window.location.href = rawData.unique_key;
        }
      } else {
      }
    } catch (error) {
      console.log("Error ::::::::: " + error);
    }
  }

  return (
    <>
      <div>
        <div className="general-settings" id="general">
          Billing Preferences
        </div>

        <div className="add-numbermain">
          <div className="tel-numbers">Billing Type</div>
          <div className="d-flex w-30">
            <select
              name=""
              id=""
              className="form-control form-select"
              //   onChange={handleBillingTypeChange}
              value={watch("billing_preference.billing_type")}
              onChange={(e) => {
                if (parseInt(e.target.value) === 1) {
                  handleCreditCard();
                } else {
                  setValue(
                    "billing_preference.billing_type",
                    parseInt(e.target.value),
                    {
                      shouldDirty: true,
                    }
                  );
                  if(parseInt(e.target.value) === 6) {
                  setValue("billing_preference.street_addr", "",{shouldDirty:true});
                  setValue("billing_preference.city", "",{shouldDirty:true});
                  setValue("billing_preference.state", "",{shouldDirty:true});
                  setValue("billing_preference.country", "",{shouldDirty:true});
                  setValue("billing_preference.zip", "",{shouldDirty:true});
                  }
                }
              }}
            >
              {billingTypesList &&
                Object.entries(billingTypesList).map(([key, value]) => (
                  <option value={key}>{value}</option>
                ))}
            </select>
          </div>
        </div>

        {watch("billing_preference.billing_type") === 1 && (
          <>
            <div className="add-numbermain">
              <div class="tel-numbers fw-500">Credit Card Info:</div>
              <MDBBtn
                onClick={(e) => {
                  e.preventDefault();
                  handleCreditCard();
                }}
              >
                Update Credit Card
              </MDBBtn>
            </div>
            <div
              className="disabled-form cursor-notAllowed"
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
              }}
            >
              <div className="add-numbermain">
                <div className="tel-numbers">Credit Card Type</div>
                <div className="d-flex w-30">
                  <div className="phoneselect w-100">
                    <MDBInput
                      {...register("billing_preference.card_info.card_type", {
                        required: "Credit card type should not be empty",
                      })}
                    />
                    {errors?.billing_preference?.card_info?.card_type && (
                      <p className="text-danger">
                        {errors?.billing_preference?.card_type?.message}
                      </p>
                    )}
                  </div>
                </div>
              </div>

              <div className="add-numbermain">
                <div className="tel-numbers">Name On Card</div>
                <div className="d-flex w-30">
                  <div className="phoneselect w-100">
                    <MDBInput
                      {...register(
                        "billing_preference.card_info.name_on_card",
                        {
                          required: "Name On Card should not be empty",
                        }
                      )}
                    />
                    {errors?.billing_preference?.card_info?.name_on_card && (
                      <p className="text-danger">
                        {
                          errors?.billing_preference?.card_info?.name_on_card
                            ?.message
                        }
                      </p>
                    )}
                  </div>
                </div>
              </div>

              <div className="add-numbermain">
                <div className="tel-numbers">Credit Card Number</div>
                <div className="d-flex w-30">
                  <div className="phoneselect w-100">
                    <MDBInput
                      {...register("billing_preference.card_info.card_number", {
                        required: "Credit Card Number should not be empty",
                      })}
                    />
                    {errors?.billing_preference?.card_info?.card_number && (
                      <p className="text-danger">
                        {
                          errors?.billing_preference?.card_info?.card_number
                            ?.message
                        }
                      </p>
                    )}
                  </div>
                </div>
              </div>

              <div className="add-numbermain">
                <div className="tel-numbers">Expiration Date</div>
                <div className="d-flex w-30">
                  <div className="phoneselect w-100">
                    <MDBInput
                      {...register("billing_preference.card_info.exp_date", {
                        required: "Expiration Date should not be empty",
                      })}
                    />
                    {errors?.billing_preference?.card_info?.exp_date && (
                      <p className="text-danger">
                        {
                          errors?.billing_preference?.card_info?.exp_date
                            ?.message
                        }
                      </p>
                    )}
                  </div>
                </div>
              </div>

              <div class="tel-numbers fw-500 pt-3">
                Credit Card Billing Address Info:
              </div>

              <div className="add-numbermain">
                <div className="tel-numbers">Street Address</div>
                <div className="d-flex w-30">
                  <div className="phoneselect w-100">
                    {/* <MDBTextArea
                    value={watch("billing_preference.street_address")}
                    onChange={(e) =>
                      setValue(
                        "billing_preference.street_address",
                        e.target.value,
                        { shouldDirty: true }
                      )
                    }
                  /> */}
                    <MDBInput
                      {...register("billing_preference.street_addr", {
                        required: "Street Address should not be empty",
                      })}
                    />
                    {errors?.billing_preference?.street_address && (
                      <p className="text-danger">
                        {errors?.billing_preference?.street_address?.message}
                      </p>
                    )}
                  </div>
                </div>
              </div>

              <div className="add-numbermain">
                <div className="tel-numbers">City/Town</div>
                <div className="d-flex w-30">
                  <div className="phoneselect w-100">
                    <MDBInput
                      {...register("billing_preference.city", {
                        required: "City/Town should not be empty",
                      })}
                    />
                    {errors?.billing_preference?.city && (
                      <p className="text-danger">
                        {errors?.billing_preference?.city?.message}
                      </p>
                    )}
                  </div>
                </div>
              </div>

              <div className="add-numbermain">
                <div className="tel-numbers">State/Province</div>
                <div className="d-flex w-30">
                  {/* <select
                    name=""
                    id=""
                    className="form-control form-select"
                    value={watch("billing_preference.state")}
                    onChange={(e) => {
                      clearErrors("billing_preference.state");
                      setValue(
                        "billing_preference.state",
                        parseInt(e.target.value),
                        {
                          shouldDirty: true,
                        }
                      );
                    }}
                  >
                    {states &&
                      states.map((loc) => (
                        <option value={parseInt(loc.sid)}>{loc.sname}</option>
                      ))}
                  </select> */}
                  <MDBInput {...register("billing_preference.state")} />
                  {errors?.billing_preference?.state && (
                    <p className="text-danger">
                      {errors?.billing_preference?.state?.message}
                    </p>
                  )}
                </div>
              </div>

              <div className="add-numbermain">
                <div className="tel-numbers">Country</div>
                <div className="d-flex w-30">
                  {/* <select
                    name=""
                    id=""
                    className="form-control form-select"
                    value={watch("billing_preference.country")}
                    onChange={(e) => {
                      clearErrors("billing_preference.country");
                      setValue("billing_preference.country", e.target.value, {
                        shouldDirty: true,
                      });
                    }}
                  >
                    {countryList &&
                      countryList.map((loc) => (
                        <option value={loc.id}>{loc.cname}</option>
                      ))}
                  </select> */}
                   <MDBInput {...register("billing_preference.country")}/>
                  {errors?.billing_preference?.country && (
                    <p className="text-danger">
                      {errors?.billing_preference?.country?.message}
                    </p>
                  )}
                </div>
              </div>

              <div className="add-numbermain">
                <div className="tel-numbers">ZIP Code</div>
                <div className="d-flex w-30">
                  <div className="phoneselect w-100">
                    <MDBInput
                      {...register("billing_preference.zip", {
                        required: "ZIP Code should not be empty",
                      })}
                    />
                    {errors?.billing_preference?.zip && (
                      <p className="text-danger">
                        {errors?.billing_preference?.zip?.message}
                      </p>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </>
        )}

        {watch("billing_preference.billing_type") === 6 && (
          <>
            <div className="add-numbermain">
              <div className="tel-numbers">
                Name on Account <span className="text-danger">*</span>
              </div>
              <div className="d-flex w-30">
                <div className="phoneselect w-100">
                  <MDBInput
                    maxLength={100}
                    {...register(
                      "billing_preference.eft_info.name_on_account",
                      {
                        required: "Name on Account should not be empty",
                      }
                    )}
                  />
                  {errors?.billing_preference?.eft_info?.name_on_account && (
                    <p className="text-danger">
                      {
                        errors?.billing_preference?.eft_info?.name_on_account
                          ?.message
                      }
                    </p>
                  )}
                </div>
              </div>
            </div>

            <div className="add-numbermain">
              <div className="tel-numbers">
                Bank Name <span className="text-danger">*</span>
              </div>
              <div className="d-flex w-30">
                <div className="phoneselect w-100">
                  <MDBInput
                    maxLength={100}
                    {...register("billing_preference.eft_info.bank_name", {
                      required: "Bank Name should not be empty",
                    })}
                  />
                  {errors?.billing_preference?.eft_info?.bank_name && (
                    <p className="text-danger">
                      {errors?.billing_preference?.eft_info?.bank_name?.message}
                    </p>
                  )}
                </div>
              </div>
            </div>

            <div className="add-numbermain">
              <div className="tel-numbers">
                Bank Routing Number <span className="text-danger">*</span>
              </div>
              <div className="d-flex w-30">
                <div className="phoneselect w-100">
                  <MDBInput
                    {...register(
                      "billing_preference.eft_info.bank_routing_number",
                      {
                        required: "Bank Routing Number should not be empty",
                      }
                    )}
                  />
                  {errors?.billing_preference?.eft_info
                    ?.bank_routing_number && (
                      <p className="text-danger">
                        {
                          errors?.billing_preference?.eft_info
                            ?.bank_routing_number?.message
                        }
                      </p>
                    )}
                </div>
              </div>
            </div>

            <div className="add-numbermain">
              <div className="tel-numbers">
                Bank Account Number <span className="text-danger">*</span>
              </div>
              <div className="d-flex w-30">
                <div className="phoneselect w-100">
                  <MDBInput
                    {...register(
                      "billing_preference.eft_info.bank_account_number",
                      {
                        required: "Bank Account Number should not be empty",
                      }
                    )}
                  />
                  {errors?.billing_preference?.eft_info
                    ?.bank_account_number && (
                      <p className="text-danger">
                        {
                          errors?.billing_preference?.eft_info
                            ?.bank_account_number?.message
                        }
                      </p>
                    )}
                </div>
              </div>
            </div>

            <div class="tel-numbers fw-500 pt-3" style={{ paddingLeft: "10px" }}>
              EFT Billing Address Info :
            </div>

            <div className="add-numbermain">
              <div className="tel-numbers">
                Street Address <span className="text-danger">*</span>
              </div>
              <div className="d-flex w-30">
                <div className="phoneselect w-100">
                  {/* <MDBTextArea
                    value={watch("billing_preference.street_address")}
                    onChange={(e) =>
                      setValue(
                        "billing_preference.street_address",
                        e.target.value,
                        { shouldDirty: true }
                      )
                    }
                  /> */}
                  <Controller
                    name="billing_preference.street_addr"
                    control={control}
                    rules={{
                      required: "Street Address should not be empty",
                    }}
                    render={({ field }) => (
                  <MDBAutocomplete
                    data={addressReasults}
                    // value={addressValue}
                    value={watch("billing_preference.street_addr")}
                    displayValue={(address) => address.street_line}
                    isLoading={isLoading}
                    // open={isDisplay}
                    // placeholder="Address 1"
                    onSearch={handleSearchAddressChange}
                    onSelect={(e) => {
                      allowAPI.current = false;
                      setisDisplay(false);
                      handleAddressSelect(e);
                    }}
                    itemContent={(address) => (
                      <div
                        onClick={(e) => {
                          e.preventDefault();
                          allowAPI.current = false;
                          handleAddressSelect(address);
                        }}
                      >
                         {address.country &&
                                                <img src={address.country === "USA" ? USA : CANADA} className='me-3' width={25} />
                                             } 
                        {address.street_line || ""}
                        {address.secondary ? ", " + address.secondary : ""}
                        {address.city ? ", " + address.city : ""}
                        {address.state ? ", " + address.state : ""}
                        {address.zipcode ? ", " + address.zipcode : ""}
                      </div>
                    )}
                  />
                   )}
/>
                  {errors?.billing_preference?.street_addr && (
                    <p className="text-danger">
                      {errors?.billing_preference?.street_addr?.message}
                    </p>
                  )}
                </div>
              </div>
            </div>

            <div className="add-numbermain">
              <div className="tel-numbers">
                City/Town <span className="text-danger">*</span>
              </div>
              <div className="d-flex w-30">
                <div className="phoneselect w-100">
                  <MDBInput
                    {...register("billing_preference.city", {
                      required: "City/Town should not be empty",
                    })}
                  />
                  {errors?.billing_preference?.city && (
                    <p className="text-danger">
                      {errors?.billing_preference?.city?.message}
                    </p>
                  )}
                </div>
              </div>
            </div>

            <div className="add-numbermain">
              <div className="tel-numbers">
                State/Province <span className="text-danger">*</span>
              </div>
              <div className="d-flex w-30 flex-column">
                 <div className="phoneselect w-100"> 
                <select
                  name=""
                  id=""
                  className="form-control form-select"{
                    ...register("billing_preference.state",{
                      required:"Please select a State/Province",
                      valueAsNumber :true
                })
                  }
                  value={watch("billing_preference.state")}
                  onChange={(e) => {
                    clearErrors("billing_preference.state");
                    setValue(
                      "billing_preference.state",
                      parseInt(e.target.value),
                      {
                        shouldDirty: true,
                      }
                    );
                  }}
                >
                  <option value="">Select State/Province</option>
                  {states &&
                    states.map((loc) => (
                      <option value={parseInt(loc.sid)}>{loc.sname}</option>
                    ))}
                </select>
                </div>
                {errors?.billing_preference?.state && (
                  <p className="text-danger">
                    {errors?.billing_preference?.state?.message}
                  </p>
                )}
              </div>
            </div>

            <div className="add-numbermain">
              <div className="tel-numbers">
                Country <span className="text-danger">*</span>
              </div>
              <div className="d-flex w-30 flex-column">
                 <div className="phoneselect w-100">
                <select
                  name=""
                  id=""
                  className="form-control form-select"
                  {...register("billing_preference.country",{
                    required:"Please select a Country"
                  })}
                  value={watch("billing_preference.country")}
                  onChange={(e) => {
                    clearErrors("billing_preference.country");
                    setValue("billing_preference.country", e.target.value, {
                      shouldDirty: true,
                    });
                  }}
                >
                  <option value="">Select Country</option>
                  {countryList &&
                    countryList.map((loc) => (
                      <option value={loc.id}>{loc.cname}</option>
                    ))}
                </select>
                </div>
                {errors?.billing_preference?.country && (
                  <p className="text-danger">
                    {errors?.billing_preference?.country?.message}
                  </p>
                )}
              </div>
            </div>

            <div className="add-numbermain">
              <div className="tel-numbers">
                ZIP Code <span className="text-danger">*</span>
              </div>
              <div className="d-flex w-30">
                <div className="phoneselect w-100">
                  <MDBInput
                    {...register("billing_preference.zip", {
                      required: "ZIP Code should not be empty",
                    })}
                  />
                  {errors?.billing_preference?.zip && (
                    <p className="text-danger">
                      {errors?.billing_preference?.zip?.message}
                    </p>
                  )}
                </div>
              </div>
            </div>
          </>
        )}
        <div className="add-numbermain">
          <div className="tel-numbers">Currency</div>
          <div className="d-flex w-30">
            <div className="phoneselect w-100">
              {watch("billing_preference.currency")}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
